import type { RouteObject } from 'react-router-dom';
import { AuthLayout } from '@widgets/layout';
import { LandingPage } from '@pages/landing-page';
import { NotFoundPage } from '@pages/error/404-not-found';

export const publicRoutes: RouteObject[] = [
  {
    path: '/',
    element: <LandingPage />,
    errorElement: <NotFoundPage />,
  },
  {
    element: <AuthLayout />,
    children: [
      {
        path: '/register',
        lazy: async () => ({
          Component: (await import('@pages/auth')).SignUpPage,
        }),
      },
    ],
  },
  {
    path: '/login',
    lazy: async () => ({
      Component: (await import('@pages/auth')).AuthenticationPage,
    }),
  },
  {
    path: '/kisi-activation',
    lazy: async () => ({
      Component: (await import('@pages/kisi-activation')).KisiActivationPage,
    }),
  },
  {
    path: '/privacy-policy',
    lazy: async () => ({
      Component: (await import('@pages/privacy-policy')).PrivacyPolicyPage,
    }),
  },
  {
    path: '/terms-and-conditions',
    lazy: async () => ({
      Component: (await import('@pages/terms-and-conditions'))
        .TermsAndConditionsPage,
    }),
  },
  {
    path: '/unauthorized-access',
    lazy: async () => ({
      Component: (await import('@pages/error/')).UnauthorizedAccessPage,
    }),
  },
  {
    //Remove Later into it's own HOC,
    path: '/temporarily-unavailable',
    lazy: async () => ({
      Component: (await import('@pages/error/')).TemporarilyUnavailablePage,
    }),
  },
  {
    path: '/account-confirmation',
    lazy: async () => ({
      Component: (await import('@pages/account-confirmation'))
        .AccountConfirmationPage,
    }),
  },
];
